import { render } from "./VehicleModelsView.vue?vue&type=template&id=2465caa6&ts=true"
import script from "./VehicleModelsView.vue?vue&type=script&lang=ts"
export * from "./VehicleModelsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__